import React, { Component } from 'react'
import Radium from 'radium'

let pulseKeyframes = Radium.keyframes(
  {
    '0%': {
      opacity: 0
    },
    '80%': {
      opacity: 0
    },
    '100%': {
      opacity: 0
    },
    '40%': {
      opacity: 1
    }
  },
  'DotSpinner'
)

let styles = size => {
  return {
    spinners: {
      display: 'inline-block',
      position: 'relative',
      textAlign: 'center',
      verticalAlign: 'middle'
    },
    spinner: {
      display: 'inline-block',
      textDecoration: 'none',
      textRendering: 'auto',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      WebkitUserSelect: 'none',
      MozUserSelect: 'none',
      MsUserSelect: 'none',
      userSelect: 'none'
    },
    spinnerDot: {
      animation: 'x 1s infinite ease-in-out',
      animationName: pulseKeyframes,
      display: 'inline-block',
      height: size.outer,
      width: size.outer,
      verticalAlign: 'top',
      backgroundColor: 'transparent',
      marginRight: size.margin
    },
    spinnerDotSecond: {
      WebkitAnimationDelay: '160ms',
      display: 'inline-block',
      animationDelay: '160ms',
      backgroundColor: 'transparent',
      marginRight: size.margin
    },
    spinnerDotThird: {
      WebkitAnimationDelay: '320ms',
      display: 'inline-block',
      animationDelay: '320ms',
      marginRight: size.margin,
      backgroundColor: 'transparent'
    },
    spinnerInner: {
      width: size.inner,
      height: size.inner,
      borderRadius: '50%',
      backgroundColor: '#1385e5',
      display: 'inline-block'
    }
  }
}

class DotSpinner extends Component {
  getSize() {
    const { kind } = this.props
    switch (kind) {
      case 'Small':
        return {
          inner: 6,
          margin: 2,
          outer: 10
        }
      default: {
        return {
          inner: 45,
          margin: 20,
          outer: 55
        }
      }
    }
  }

  render() {
    let style = styles(this.getSize())
    return (
      <div>
        <div style={[style.spinners, style.spinner]}>
          <i style={[style.spinnerDot]}>
            <span style={[style.spinnerInner]} />
          </i>
          <i style={[style.spinnerDot, style.spinnerDotSecond]}>
            <span style={[style.spinnerInner]} />
          </i>
          <i style={[style.spinnerDot, style.spinnerDotThird]}>
            <span style={[style.spinnerInner]} />
          </i>
        </div>
      </div>
    )
  }
}

export default Radium(DotSpinner)



// WEBPACK FOOTER //
// ./src/components/App/dotSpinner.js